import { BoltApiClient } from "@bolt/core";
import { BoltDocument } from "../../types/types";

export class BoltDocumentApiClient {
  constructor(private readonly boltApiClient: BoltApiClient) {}
  async getDocuments(documentIds: string[]): Promise<BoltDocument[]> {
    return this.boltApiClient.post<BoltDocument[]>(
      `/documents/fetch`,
      documentIds
    );
  }

  async removeDocument(documentId: string): Promise<void> {
    return this.boltApiClient.delete<void>(`/documents/${documentId}`);
  }
}

export const createBoltDocumentApiClient = (boltApiClient: BoltApiClient) => {
  return new BoltDocumentApiClient(boltApiClient);
};
